import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Box } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import AddonRow from './AddonRow.tsx';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const RefundedRow = ({ foodItem }: any) => {
    const [open, setOpen] = React.useState(false);

    const GetFoodItemSubTotal = (item) => {
        var total = (item.basePrice || 0) * (item.initialQty || item.qty || 1);
        var addonTotal = Array.isArray(item.addons) && item.addons.length > 0
            ? item.addons.reduce((accumulator, addon) => {
                let addonSubTotal = (addon.basePrice || 0) * (addon.qty || 1);
                if (Array.isArray(addon.options) && addon.options.length > 0) {
                    addon.options.forEach(option => {
                        addonSubTotal += (option.basePrice || 0) * (option.qty || 0);
                        if (Array.isArray(option.subOptions) && option.subOptions.length > 0) {
                            option.subOptions.forEach(subOption => {
                                addonSubTotal += (subOption.basePrice || 0) * (subOption.subOptionQuantity || 0);
                            });
                        }
                    });
                }
                return accumulator + addonSubTotal;
            }, 0) : 0;
        return (total + addonTotal).toFixed(2);
    }

    return (
        <>
            <TableRow>
                <TableCell align="left">
                    <IconButton size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>
                <TableCell align="left">{foodItem?.orderItemName} <span className='fs-1'>.</span> <em className='text-danger fw-bold'>Refunded</em></TableCell>
                <TableCell align="center"># {foodItem?.transactionId?.slice(-6)}</TableCell>
                <TableCell align="center">
                    {new Date(foodItem?.dateTime).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                    })}
                </TableCell>
                <TableCell align="center">{foodItem?.qty}</TableCell>
                <TableCell align='center'>{foodItem.refundedQuantity}</TableCell>
                <TableCell align="center">{foodItem.refundedAmount}</TableCell>
                <TableCell align="center">{foodItem?.matchedOrderId?.slice(-6) ?? "N/A"}</TableCell>
                <TableCell align="center">{foodItem.matchedOrderAmount ?? "N/A"}</TableCell>
                <TableCell align="center">£ {GetFoodItemSubTotal(foodItem)}</TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit sx={{ width: "120%" }}>
                        {foodItem?.addons?.length > 0 ?
                            <Box sx={{ margin: 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    Add ons
                                </Typography>
                                <Table size="small" aria-label="food-items">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell align='left'>Addon Name</TableCell>
                                            <TableCell align="center">VAT Per Addon</TableCell>
                                            <TableCell align="center">SD Per Addon</TableCell>
                                            <TableCell align="center">Addon Quantity</TableCell>
                                            <TableCell align="center">Addon Base Price</TableCell>
                                            <TableCell align="center" style={{ textWrap: 'nowrap' }}>Addon Sub Total</TableCell>
                                            <TableCell align="center" style={{ textWrap: 'nowrap' }}>Addon Total Price</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {open && foodItem?.addons?.length > 0 && foodItem.addons.map((addon, index) => (
                                            <AddonRow key={index} addon={addon} />
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                            : ""
                        }
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default RefundedRow;